// import { Box, Tab, Tabs } from '@mui/material'
// import React from 'react'
// import ProductType from './ProductType';
// import CategoryMenu from './CategoryMenu';

// const Metadata = () => {

//     const [value, setValue] = React.useState(0);

//     const handleChange = (event, newValue) => {
//         setValue(newValue);
//     };

//     const a11yProps = (index) => {
//         return {
//             id: `simple-tab-${index}`,
//             'aria-controls': `simple-tabpanel-${index}`,
//         };
//     }

//     const CustomTabPanel = (props) => {
//         const { children, value, index, ...other } = props;

//         return (
//             <div
//                 role="tabpanel"
//                 hidden={value !== index}
//                 id={`simple-tabpanel-${index}`}
//                 aria-labelledby={`simple-tab-${index}`}
//                 {...other}
//             >
//                 {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
//             </div>
//         );
//     }

//     return (
//         <Box sx={{ width: '100%' }}>
//             <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
//                 <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
//                     <Tab sx={{ fontWeight: 600 }} label="Product Type" {...a11yProps(0)} />
//                     <Tab sx={{ fontWeight: 600 }} label="Category" {...a11yProps(1)} />
//                     <Tab sx={{ fontWeight: 600 }} label="Placeholders" {...a11yProps(1)} />
//                 </Tabs>
//             </Box>
//             <CustomTabPanel value={value} index={0}>
//                 <ProductType />
//             </CustomTabPanel>
//             <CustomTabPanel value={value} index={1}>
//                 <CategoryMenu />
//             </CustomTabPanel>
//             <CustomTabPanel value={value} index={2}>
//                 ⏳ Upcoming
//             </CustomTabPanel>
//         </Box>
//     )
// }

// export default Metadata

import { Box, Tab, Tabs, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import ProductType from './ProductType';
import CategoryMenu from './CategoryMenu';
import PageHeader from "../../Components/UI/PageHeader";
import SectionCard from "../../Components/UI/SectionCard";

const  Metadata = () => {
  const [value, setValue] = React.useState(0);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const a11yProps = (index) => {
    return {
      id: `tab-${index}`,
      'aria-controls': `tabpanel-${index}`,
    };
  };

  const CustomTabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: isMobile ? 1 : 3 }}>
            {children}
          </Box>
        )}
      </div>
    );
  };

  return (
    <Box sx={{ display: "grid", gap: 2 }}>
      <PageHeader
        title="Metadata"
        subtitle="Manage product metadata like product types and categories."
      />

      <SectionCard title="Configuration">
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 1 : 0,
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            variant={isMobile ? "scrollable" : "standard"}
            scrollButtons={isMobile ? "auto" : false}
            aria-label="metadata tabs"
          >
            <Tab label="Product Type" sx={{ fontWeight: 800 }} {...a11yProps(0)} />
            <Tab label="Category" sx={{ fontWeight: 800 }} {...a11yProps(1)} />
            <Tab label="Placeholders" sx={{ fontWeight: 800 }} {...a11yProps(2)} />
          </Tabs>
        </Box>

        <CustomTabPanel value={value} index={0}>
          <ProductType />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <CategoryMenu />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          ⏳ Upcoming
        </CustomTabPanel>
      </SectionCard>
    </Box>
  )
}
export default Metadata